module.exports = __webpack_public_path__ + "fonts/NanumSquareOTFR.ec712872.woff";